export const ENV = {
  API_URL: __myapp?.env?.SVELTE_APP_API_URL,
  FRONT_URL: __myapp?.env?.SVELTE_APP_FRONT_URL,
};
